import React, { useEffect, useRef, useState } from "react";
import DocSearchBlock from "./DocSearchBlock";
import FileMenus from "./FileMenus";
import '../../../assets/css/common/document/sidebar_list.scss';
import LoadMore from "../../../components/common/LoadMore";
import LoaderUI from "../../../components/common/loader/index";
import TitleBlock from "../../../components/common/TitleBlock";
import NoRecord from "../../../components/common/NoRecord";
import TotalCount from "../../../components/common/TotalCount";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import { navigationAction } from "../../../context/actions/navigationAction";

const SidebarList = ({ autoSaveFileVersion, filterSelected, title,
	sortBySelected,
	filterSelectedFn, sortBySelectedFn,
	sortFn, page, list, handleSelectedAction, _filter, _loader, __filter, _resetFilter, search, handlePageChange, sidebarLoading, sidebarLoadingLabel, sidbarLoadingButton, _innerLodder, handleElasticSearch, elasticSearchList, focusSearchFlag, _focusSearch, totalDocRecords, documentExclude, hasNextPage, hasPrevPage  }) => {

    console.log('totalDocRecords',totalDocRecords)

	const [reviewRequested, setReviewRequested] = useState(false)
	const [otherDocuments, setOtherDocuments] = useState(true)


	const _handleSelected = (id) => {
		handleSelectedAction(id);
	};
	const _search = (val) => {
		search(val);
	};
	const _handlePageChange = (activePage) => {
		
		handlePageChange(activePage, reviewRequested, otherDocuments);
	};
	const dispatch = useDispatch();
	const navigationState = useSelector((state) => state.navigationReducer.isOn);
	const navigationHandler = () => {
		dispatch(navigationAction(!navigationState));
	}
	return (
		<>
			<div className={`sidebar-list d-flex flex-column flex-fill overflow-auto  ${_loader ? "disable" : ""} `}>
				<div className="panel-close-rw text-end">
					<Button color="link" className="close-btn" onClick={navigationHandler}>X</Button>
				</div>
				<DocSearchBlock autoSaveFileVersion={autoSaveFileVersion} filterSelected={filterSelected}
					sortBySelected={sortBySelected}
					filterSelectedFn={filterSelectedFn} sortBySelectedFn={sortBySelectedFn}
					_resetFilter={_resetFilter} _filterDocs={_filter} __filterDocs={__filter} _handleSearch={(val) => _search(val)} _handleElasticSearch={(val) => handleElasticSearch(val)} elasticSearchList={elasticSearchList} focusSearchFlag={focusSearchFlag} __focusSearch={(val => _focusSearch(val))} />
				<TitleBlock label={title} />
				
				
				<div className="refresh-list-hd d-flex align-items-center 0000">
					{<TotalCount className="sidebarListBlc" name={`Total Files`} records={totalDocRecords} />}
				</div>
				<div className="inner-blc d-flex flex-column flex-fill overflow-auto position-relative" id="123">
					{!_innerLodder ? list.length ?
						(
							<FileMenus autoSaveFileVersion={autoSaveFileVersion} sortFn={sortFn} list={list} _handleSelectedAction={(id) => _handleSelected(id)} />

						) : <NoRecord /> : <LoaderUI FullWindow={false} inContainer={true} />}
				</div>

				<div class="pagin_cust"><div onClick={() => {_handlePageChange(page-1, reviewRequested, otherDocuments)}} className={`prev ${ !hasPrevPage ? "disabled" : ""}`}><div><i class="fas fa-angle-left"></i>Prev</div></div>
				{/* {sidbarLoadingButton && <LoadMore page={page} __handlePageChange={(activePage) => _handlePageChange(activePage, reviewRequested, otherDocuments)} loading={sidebarLoading} label={sidebarLoadingLabel} />} */}
				<div onClick={() => {_handlePageChange(page+1, reviewRequested, otherDocuments)}} className={`next ${ !hasNextPage ? "disabled" : ""}`}><div>Next <i class="fas fa-angle-right"></i></div></div></div>

				{/* {sidbarLoadingButton && <LoadMore page={page} __handlePageChange={(activePage) => _handlePageChange(activePage)} loading={sidebarLoading} label={sidebarLoadingLabel} />} */}
			</div>
		</>
	);
};
export default SidebarList;
